export default class Messenger {
    constructor() {
        this.listeners = {};
    }

    /**
     * @param {string} key
     * @param {function} listener
     */
    subscribe(key, listener) {
        if(this.listeners[key] === undefined) {
            this.listeners[key] = [];
        }

        this.listeners[key].push(listener);
    }

    /**
     * @param {string} key
     * @param {object} data
     */
    publish(key, data) {
        let listeners = this.listeners[key];

        if(listeners === undefined || listeners === null)
            listeners = [];

        listeners.forEach((listener) => {
            listener(data);
    });
    }

	/**
	 * @param {string} key
	 */
    remove(key) {
	    if(this.listeners[key] !== undefined) {
		    this.listeners[key] = [];
	    }
    }
}


/** WEBPACK FOOTER **
 ** ./src/modules/common/Messenger.js
 **/